export default "__VITE_ASSET__6cOR0khw__"